export interface Language {
  code: string;
  name: string;
  nativeName: string;
  flag: string;
  dir?: 'ltr' | 'rtl';
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', dir: 'ltr' }
];

export const DEFAULT_LANGUAGE = 'en';

// Extract language code from URL pathname
export function getLangFromPath(pathname: string): string {
  return DEFAULT_LANGUAGE;
}

// Strip language code from URL pathname to get normalized route
export function getNormalizedPath(pathname: string): string {
  return pathname || '/';
}

// Build URL path with language subpath
export function buildLangPath(route: string, langCode: string): string {
  const cleanRoute = route;
  return cleanRoute.startsWith('/') ? cleanRoute : `/${cleanRoute}`;
}
